/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * planet object
 * @export
 * @interface GetUniverseSystemsSystemIdPlanet
 */
export interface GetUniverseSystemsSystemIdPlanet {
    /**
     * asteroid_belts array
     * @type {Array<number>}
     * @memberof GetUniverseSystemsSystemIdPlanet
     */
    asteroidBelts?: Array<number>;
    /**
     * moons array
     * @type {Array<number>}
     * @memberof GetUniverseSystemsSystemIdPlanet
     */
    moons?: Array<number>;
    /**
     * planet_id integer
     * @type {number}
     * @memberof GetUniverseSystemsSystemIdPlanet
     */
    planetId: number;
}

/**
 * Check if a given object implements the GetUniverseSystemsSystemIdPlanet interface.
 */
export function instanceOfGetUniverseSystemsSystemIdPlanet(value: object): value is GetUniverseSystemsSystemIdPlanet {
    if (!('planetId' in value) || value['planetId'] === undefined) return false;
    return true;
}

export function GetUniverseSystemsSystemIdPlanetFromJSON(json: any): GetUniverseSystemsSystemIdPlanet {
    return GetUniverseSystemsSystemIdPlanetFromJSONTyped(json, false);
}

export function GetUniverseSystemsSystemIdPlanetFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseSystemsSystemIdPlanet {
    if (json == null) {
        return json;
    }
    return {
        
        'asteroidBelts': json['asteroid_belts'] == null ? undefined : json['asteroid_belts'],
        'moons': json['moons'] == null ? undefined : json['moons'],
        'planetId': json['planet_id'],
    };
}

export function GetUniverseSystemsSystemIdPlanetToJSON(json: any): GetUniverseSystemsSystemIdPlanet {
    return GetUniverseSystemsSystemIdPlanetToJSONTyped(json, false);
}

export function GetUniverseSystemsSystemIdPlanetToJSONTyped(value?: GetUniverseSystemsSystemIdPlanet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'asteroid_belts': value['asteroidBelts'],
        'moons': value['moons'],
        'planet_id': value['planetId'],
    };
}

